export default __webpack_public_path__ + "media/Fisheye_mobile.b2c2c7a1fc0f2b6d1d26888eca496621.svg";